import {
  CheckboxFieldRHF,
  FormErrorRHF,
  FormRHF,
  Input,
  InputFieldRHF,
  SubmitButtonRHF,
} from '../../tailwind-ui';

import type { HandleSubmitNewsletterForm } from './utils';
import { defaultValues, schema } from './utils';

interface NewsletterFormProps {
  handleSubmit: (values: HandleSubmitNewsletterForm) => Promise<void>;
}

export function NewsletterForm(props: NewsletterFormProps) {
  const { handleSubmit } = props;

  return (
    <FormRHF
      defaultValues={defaultValues}
      className="flex flex-col gap-2 flex-1"
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <div className="hidden">
        {/* This is a fake honeypot field to detect bots. */}
        <Input name="Name" label="name" hiddenLabel placeholder="Your name" />
      </div>
      <InputFieldRHF
        label="Email address"
        name="email"
        required
        placeholder="Enter your email"
        autoComplete="email"
        className="w-full"
      />

      <CheckboxFieldRHF
        name="educational"
        label="Include educational content"
        className="w-full"
      />

      <FormErrorRHF />

      <div className="flex flex-1 justify-between items-end">
        <a
          className="text-neutral-500 hover:text-primary-500 hover:underline text-sm"
          target="_blank"
          rel="noopener"
          href="/privacy-policy.html"
        >
          Privacy policy
        </a>
        <SubmitButtonRHF>Subscribe</SubmitButtonRHF>
      </div>
    </FormRHF>
  );
}
